import * as React from "react";
import { t } from "../../i18n/util";
import { API } from "../../network/API";
import { GetUserInfoResponse } from "../../network/APITypes";
import { generalStore } from "../../stores/GeneralStore";

export const useUserInfo = () => {
    const [userInfo, setUserInfo] = React.useState<GetUserInfoResponse | null>(null);
    const [loadFailed, setLoadFailed] = React.useState(false);

    React.useEffect(() => {
        const load = async () => {
            try {
                generalStore.isLoading = true;
                const response = await API.getUserInfo();

                if (response) {
                    setUserInfo(response);
                }
            } catch (err) {
                generalStore.setError(t("error.loadUserInfo"), err);
                setLoadFailed(true);
            } finally {
                generalStore.isLoading = false;
            }
        };

        load();
    }, []);

    return { userInfo, loadFailed };
};
